// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MODERN NAVIGATION BAR
   ============================================ */

:root {
  --nav-height: 95px;
  --nav-bg: #ffffff;
  --nav-text: #0d141b;
  --nav-text-hover: #400C4D;
  --nav-active: #400C4D;
  --nav-border: #e2e8f0;
  --nav-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);
  --nav-transition: all 0.3s ease;
  --nav-orange: #f97316;
  --nav-green: #16a34a;
}

/* ============================================
   MAIN NAVIGATION
   ============================================ */

.nav {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  height: var(--nav-height);
  background: var(--nav-bg);
  border-bottom: 1px solid transparent;
  z-index: 1000;
  transition: var(--nav-transition);
}

.nav--scrolled {
  border-bottom-color: var(--nav-border);
  box-shadow: var(--nav-shadow);
}

.nav__container {
  max-width: 1800px;
  height: 100%;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}

@media (min-width: 1400px) {
  .nav__container {
    padding: 0 3rem;
    gap: 2.5rem;
  }
}

@media (min-width: 1600px) {
  .nav__container {
    padding: 0 4rem;
    gap: 3rem;
  }
}

/* ============================================
   LOGO
   ============================================ */

.nav__logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
}

.nav__logo-img {
  height: 85px;
  width: auto;
  display: block;
}

/* ============================================
   DESKTOP MENU
   ============================================ */

.nav__menu {
  display: none;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  justify-content: center;
  max-width: 1200px;
}

@media (min-width: 1100px) {
  .nav__menu {
    display: flex;
  }
}

.nav__link {
  position: relative;
  padding: 0.7rem 0.85rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--nav-text);
  text-decoration: none;
  border-radius: 10px;
  transition: var(--nav-transition);
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.nav__link:hover {
  color: var(--nav-text-hover);
  background: rgba(64, 12, 77, 0.06);
  transform: translateY(-1px);
}

.nav__link--active {
  color: var(--nav-active);
  background: linear-gradient(135deg, rgba(64, 12, 77, 0.1) 0%, rgba(64, 12, 77, 0.15) 100%);
  box-shadow: 0 2px 8px rgba(64, 12, 77, 0.15);
}

/* Sathi Link with Icon - GREEN */
.nav__link--sathi {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;
  border: 2px solid #bbf7d0 !important;
  color: #16a34a !important;
  font-weight: 700;
  box-shadow: none !important;
  padding: 0.6rem 1.5rem 0.6rem 1rem !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 0.5rem !important;
}

.nav__link--sathi::after {
  display: none !important;
  content: none !important;
}

.nav__link--sathi:hover {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%) !important;
  border-color: #86efac !important;
  color: #15803d !important;
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25) !important;
}

.nav__sathi-icon {
  height: 20px;
  width: auto;
  flex-shrink: 0;
}

/* ============================================
   RIGHT ACTIONS
   ============================================ */

.nav__actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

@media (min-width: 1400px) {
  .nav__actions {
    gap: 1rem;
  }
}

/* Login Button - PURPLE */
.nav__btn {
  display: none;
  padding: 0.7rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #400C4D 0%, #5a1761 100%);
  text-decoration: none;
  border-radius: 10px;
  transition: var(--nav-transition);
  box-shadow: 0 4px 12px rgba(64, 12, 77, 0.3);
  white-space: nowrap;
}

@media (min-width: 1100px) {
  .nav__btn {
    display: inline-block;
  }
}

.nav__btn:hover {
  background: linear-gradient(135deg, #5a1761 0%, #7a1f7f 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(64, 12, 77, 0.4);
}

/* Course Launch Button - ORANGE/ACCENT */
.nav__launch-btn {
  display: none;
  padding: 0.7rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);
  text-decoration: none;
  border: none;
  border-radius: 10px;
  transition: var(--nav-transition);
  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);
  white-space: nowrap;
  cursor: pointer;
  animation: pulse-glow 2s ease-in-out infinite;
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);
  }
  50% {
    box-shadow: 0 4px 16px rgba(249, 115, 22, 0.5), 0 0 20px rgba(249, 115, 22, 0.2);
  }
}

@media (min-width: 1100px) {
  .nav__launch-btn {
    display: inline-block;
  }
}

.nav__launch-btn:hover {
  background: linear-gradient(135deg, #ea580c 0%, #f97316 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(249, 115, 22, 0.5);
  animation: none;
}

/* Call Button - GREEN */
.nav__call-btn {
  display: none;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #ffffff;
  text-decoration: none;
  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
  border-radius: 10px;
  transition: var(--nav-transition);
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);
  white-space: nowrap;
}

.nav__call-btn::after {
  display: none !important;
  content: none !important;
}

@media (min-width: 1100px) {
  .nav__call-btn {
    display: flex;
  }
}

.nav__call-btn:hover {
  background: linear-gradient(135deg, #22c55e 0%, #4ade80 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(22, 163, 74, 0.4);
}

.nav__call-icon {
  width: 18px;
  height: 18px;
}

/* Remove old phone number styles */
.nav__phone {
  display: none !important;
}

.nav__phone-text {
  white-space: nowrap;
}

/* Compact desktop: keep every item (incl. Call) on screen on laptop widths */
@media (min-width: 1100px) and (max-width: 1549px) {
  .nav__container {
    padding: 0 1.25rem;
    gap: 0.75rem;
  }

  .nav__logo-img {
    height: 72px;
  }

  .nav__menu {
    gap: 0.1rem;
    min-width: 0;
  }

  .nav__link {
    padding: 0.55rem 0.6rem;
    font-size: 0.98rem;
  }

  .nav__link--sathi {
    padding: 0.45rem 0.9rem 0.45rem 0.7rem !important;
  }

  .nav__actions {
    gap: 0.5rem;
  }

  .nav__launch-btn,
  .nav__btn,
  .nav__call-btn {
    padding: 0.6rem 0.95rem;
    font-size: 0.9rem;
  }
}

/* Small laptops: tighter links */
@media (min-width: 1100px) and (max-width: 1365px) {
  .nav__link {
    padding: 0.5rem 0.45rem;
    font-size: 0.92rem;
  }
}

/* Narrowest desktop: Call becomes an icon button */
@media (min-width: 1100px) and (max-width: 1239px) {
  .nav__call-btn {
    padding: 0.6rem 0.7rem;
  }

  .nav__call-text {
    display: none;
  }
}

/* Hamburger Menu */
.nav__hamburger {
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  z-index: 10;
}

@media (min-width: 1100px) {
  .nav__hamburger {
    display: none;
  }
}

.nav__hamburger span {
  width: 24px;
  height: 2.5px;
  background: var(--nav-text);
  border-radius: 2px;
  transition: var(--nav-transition);
}

.nav__hamburger:hover span {
  background: var(--nav-text-hover);
}

/* ============================================
   MOBILE MENU
   ============================================ */

.nav__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 9998;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.nav__mobile {
  position: fixed;
  top: 0;
  right: -100%;
  bottom: 0;
  width: 320px;
  max-width: 85vw;
  background: #ffffff;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  transition: right 0.3s ease;
}

.nav__mobile--open {
  right: 0;
}

.nav__mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--nav-border);
}

.nav__mobile-close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border: none;
  border-radius: 8px;
  font-size: 1.5rem;
  color: var(--nav-text);
  cursor: pointer;
  transition: var(--nav-transition);
}

.nav__mobile-close:hover {
  background: #e2e8f0;
  color: #ef4444;
}

.nav__mobile-links {
  flex: 1;
  overflow-y: auto;
  padding: 1rem 0;
}

.nav__mobile-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--nav-text);
  text-decoration: none;
  border-left: 3px solid transparent;
  transition: var(--nav-transition);
}

.nav__mobile-link:hover {
  background: rgba(64, 12, 77, 0.05);
  color: var(--nav-text-hover);
  border-left-color: var(--nav-text-hover);
}

.nav__mobile-link--active {
  background: rgba(64, 12, 77, 0.08);
  color: var(--nav-active);
  border-left-color: var(--nav-active);
}

.nav__mobile-link--sathi {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;
  border-left-color: #16a34a !important;
  color: #16a34a !important;
}

.nav__mobile-footer {
  padding: 1.5rem;
  border-top: 1px solid var(--nav-border);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.nav__mobile-btn {
  display: block;
  padding: 1rem;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #400C4D 0%, #5a1761 100%);
  text-decoration: none;
  border-radius: 10px;
  transition: var(--nav-transition);
  box-shadow: 0 4px 12px rgba(64, 12, 77, 0.3);
}

.nav__mobile-btn:hover {
  background: linear-gradient(135deg, #5a1761 0%, #7a1f7f 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(64, 12, 77, 0.4);
}

/* Mobile Course Launch Button */
.nav__mobile-launch-btn {
  display: block;
  padding: 1rem;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);
  text-decoration: none;
  border: none;
  border-radius: 10px;
  transition: var(--nav-transition);
  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);
  cursor: pointer;
  animation: pulse-glow 2s ease-in-out infinite;
}

.nav__mobile-launch-btn:hover {
  background: linear-gradient(135deg, #ea580c 0%, #f97316 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(249, 115, 22, 0.5);
  animation: none;
}

.nav__mobile-phone {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 1rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #16a34a;
  text-decoration: none;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 2px solid #bbf7d0;
  border-radius: 10px;
  transition: var(--nav-transition);
}

.nav__mobile-phone:hover {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  border-color: #86efac;
  transform: translateY(-1px);
}

/* ============================================
   RESPONSIVE ADJUSTMENTS
   ============================================ */

@media (max-width: 768px) {
  .nav__container {
    padding: 0 1.5rem;
  }

  .nav__logo-img {
    height: 60px;
  }

  .nav__mobile {
    width: 280px;
  }
}

@media (max-width: 480px) {
  .nav__container {
    padding: 0 1rem;
  }

  .nav__logo-img {
    height: 45px;
  }

  .nav__mobile {
    width: 100%;
    max-width: 100vw;
  }
}

/* ============================================
   DARK MODE SUPPORT (OPTIONAL)
   ============================================ */

html[data-theme="dark"] .nav {
  --nav-bg: #0f172a;
  --nav-text: #e2e8f0;
  --nav-text-hover: #d8b4fe;
  --nav-active: #c084fc;
  --nav-border: #1e293b;
}

html[data-theme="dark"] .nav__mobile {
  background: #0f172a;
}

html[data-theme="dark"] .nav__mobile-close {
  background: #1e293b;
  color: #e2e8f0;
}

html[data-theme="dark"] .nav__mobile-close:hover {
  background: #334155;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Navigation/navigation.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,4CAA4C;EAC5C,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,0FAA0F;EAC1F,4CAA4C;AAC9C;;AAEA,iCAAiC;AACjC;EACE,wEAAwE;EACxE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,6CAA6C;EAC7C,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,wEAAwE;EACxE,gCAAgC;EAChC,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;EACjC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,8CAA8C;EAC9C,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE;IACE,8CAA8C;EAChD;EACA;IACE,gFAAgF;EAClF;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;EAC9C,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,6DAA6D;EAC7D,mBAAmB;EACnB,iCAAiC;EACjC,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,uBAAuB;IACvB,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,wEAAwE;EACxE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,8CAA8C;EAC9C,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ============================================\n   MODERN NAVIGATION BAR\n   ============================================ */\n\n:root {\n  --nav-height: 95px;\n  --nav-bg: #ffffff;\n  --nav-text: #0d141b;\n  --nav-text-hover: #400C4D;\n  --nav-active: #400C4D;\n  --nav-border: #e2e8f0;\n  --nav-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);\n  --nav-transition: all 0.3s ease;\n  --nav-orange: #f97316;\n  --nav-green: #16a34a;\n}\n\n/* ============================================\n   MAIN NAVIGATION\n   ============================================ */\n\n.nav {\n  position: sticky;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: var(--nav-height);\n  background: var(--nav-bg);\n  border-bottom: 1px solid transparent;\n  z-index: 1000;\n  transition: var(--nav-transition);\n}\n\n.nav--scrolled {\n  border-bottom-color: var(--nav-border);\n  box-shadow: var(--nav-shadow);\n}\n\n.nav__container {\n  max-width: 1800px;\n  height: 100%;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n}\n\n@media (min-width: 1400px) {\n  .nav__container {\n    padding: 0 3rem;\n    gap: 2.5rem;\n  }\n}\n\n@media (min-width: 1600px) {\n  .nav__container {\n    padding: 0 4rem;\n    gap: 3rem;\n  }\n}\n\n/* ============================================\n   LOGO\n   ============================================ */\n\n.nav__logo {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n.nav__logo-img {\n  height: 85px;\n  width: auto;\n  display: block;\n}\n\n/* ============================================\n   DESKTOP MENU\n   ============================================ */\n\n.nav__menu {\n  display: none;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 1;\n  justify-content: center;\n  max-width: 1200px;\n}\n\n@media (min-width: 1100px) {\n  .nav__menu {\n    display: flex;\n  }\n}\n\n.nav__link {\n  position: relative;\n  padding: 0.7rem 0.85rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--nav-text);\n  text-decoration: none;\n  border-radius: 10px;\n  transition: var(--nav-transition);\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.nav__link:hover {\n  color: var(--nav-text-hover);\n  background: rgba(64, 12, 77, 0.06);\n  transform: translateY(-1px);\n}\n\n.nav__link--active {\n  color: var(--nav-active);\n  background: linear-gradient(135deg, rgba(64, 12, 77, 0.1) 0%, rgba(64, 12, 77, 0.15) 100%);\n  box-shadow: 0 2px 8px rgba(64, 12, 77, 0.15);\n}\n\n/* Sathi Link with Icon - GREEN */\n.nav__link--sathi {\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;\n  border: 2px solid #bbf7d0 !important;\n  color: #16a34a !important;\n  font-weight: 700;\n  box-shadow: none !important;\n  padding: 0.6rem 1.5rem 0.6rem 1rem !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 0.5rem !important;\n}\n\n.nav__link--sathi::after {\n  display: none !important;\n  content: none !important;\n}\n\n.nav__link--sathi:hover {\n  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%) !important;\n  border-color: #86efac !important;\n  color: #15803d !important;\n  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25) !important;\n}\n\n.nav__sathi-icon {\n  height: 20px;\n  width: auto;\n  flex-shrink: 0;\n}\n\n/* ============================================\n   RIGHT ACTIONS\n   ============================================ */\n\n.nav__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-shrink: 0;\n}\n\n@media (min-width: 1400px) {\n  .nav__actions {\n    gap: 1rem;\n  }\n}\n\n/* Login Button - PURPLE */\n.nav__btn {\n  display: none;\n  padding: 0.7rem 1.25rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #ffffff;\n  background: linear-gradient(135deg, #400C4D 0%, #5a1761 100%);\n  text-decoration: none;\n  border-radius: 10px;\n  transition: var(--nav-transition);\n  box-shadow: 0 4px 12px rgba(64, 12, 77, 0.3);\n  white-space: nowrap;\n}\n\n@media (min-width: 1100px) {\n  .nav__btn {\n    display: inline-block;\n  }\n}\n\n.nav__btn:hover {\n  background: linear-gradient(135deg, #5a1761 0%, #7a1f7f 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(64, 12, 77, 0.4);\n}\n\n/* Course Launch Button - ORANGE/ACCENT */\n.nav__launch-btn {\n  display: none;\n  padding: 0.7rem 1.25rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #ffffff;\n  background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);\n  text-decoration: none;\n  border: none;\n  border-radius: 10px;\n  transition: var(--nav-transition);\n  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);\n  white-space: nowrap;\n  cursor: pointer;\n  animation: pulse-glow 2s ease-in-out infinite;\n}\n\n@keyframes pulse-glow {\n  0%, 100% {\n    box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);\n  }\n  50% {\n    box-shadow: 0 4px 16px rgba(249, 115, 22, 0.5), 0 0 20px rgba(249, 115, 22, 0.2);\n  }\n}\n\n@media (min-width: 1100px) {\n  .nav__launch-btn {\n    display: inline-block;\n  }\n}\n\n.nav__launch-btn:hover {\n  background: linear-gradient(135deg, #ea580c 0%, #f97316 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(249, 115, 22, 0.5);\n  animation: none;\n}\n\n/* Call Button - GREEN */\n.nav__call-btn {\n  display: none;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.7rem 1.25rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #ffffff;\n  text-decoration: none;\n  background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);\n  border-radius: 10px;\n  transition: var(--nav-transition);\n  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);\n  white-space: nowrap;\n}\n\n.nav__call-btn::after {\n  display: none !important;\n  content: none !important;\n}\n\n@media (min-width: 1100px) {\n  .nav__call-btn {\n    display: flex;\n  }\n}\n\n.nav__call-btn:hover {\n  background: linear-gradient(135deg, #22c55e 0%, #4ade80 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(22, 163, 74, 0.4);\n}\n\n.nav__call-icon {\n  width: 18px;\n  height: 18px;\n}\n\n/* Remove old phone number styles */\n.nav__phone {\n  display: none !important;\n}\n\n.nav__phone-text {\n  white-space: nowrap;\n}\n\n/* Compact desktop: keep every item (incl. Call) on screen on laptop widths */\n@media (min-width: 1100px) and (max-width: 1549px) {\n  .nav__container {\n    padding: 0 1.25rem;\n    gap: 0.75rem;\n  }\n\n  .nav__logo-img {\n    height: 72px;\n  }\n\n  .nav__menu {\n    gap: 0.1rem;\n    min-width: 0;\n  }\n\n  .nav__link {\n    padding: 0.55rem 0.6rem;\n    font-size: 0.98rem;\n  }\n\n  .nav__link--sathi {\n    padding: 0.45rem 0.9rem 0.45rem 0.7rem !important;\n  }\n\n  .nav__actions {\n    gap: 0.5rem;\n  }\n\n  .nav__launch-btn,\n  .nav__btn,\n  .nav__call-btn {\n    padding: 0.6rem 0.95rem;\n    font-size: 0.9rem;\n  }\n}\n\n/* Small laptops: tighter links */\n@media (min-width: 1100px) and (max-width: 1365px) {\n  .nav__link {\n    padding: 0.5rem 0.45rem;\n    font-size: 0.92rem;\n  }\n}\n\n/* Narrowest desktop: Call becomes an icon button */\n@media (min-width: 1100px) and (max-width: 1239px) {\n  .nav__call-btn {\n    padding: 0.6rem 0.7rem;\n  }\n\n  .nav__call-text {\n    display: none;\n  }\n}\n\n/* Hamburger Menu */\n.nav__hamburger {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  cursor: pointer;\n  z-index: 10;\n}\n\n@media (min-width: 1100px) {\n  .nav__hamburger {\n    display: none;\n  }\n}\n\n.nav__hamburger span {\n  width: 24px;\n  height: 2.5px;\n  background: var(--nav-text);\n  border-radius: 2px;\n  transition: var(--nav-transition);\n}\n\n.nav__hamburger:hover span {\n  background: var(--nav-text-hover);\n}\n\n/* ============================================\n   MOBILE MENU\n   ============================================ */\n\n.nav__overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  z-index: 9998;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.nav__mobile {\n  position: fixed;\n  top: 0;\n  right: -100%;\n  bottom: 0;\n  width: 320px;\n  max-width: 85vw;\n  background: #ffffff;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  transition: right 0.3s ease;\n}\n\n.nav__mobile--open {\n  right: 0;\n}\n\n.nav__mobile-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--nav-border);\n}\n\n.nav__mobile-close {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f5f9;\n  border: none;\n  border-radius: 8px;\n  font-size: 1.5rem;\n  color: var(--nav-text);\n  cursor: pointer;\n  transition: var(--nav-transition);\n}\n\n.nav__mobile-close:hover {\n  background: #e2e8f0;\n  color: #ef4444;\n}\n\n.nav__mobile-links {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem 0;\n}\n\n.nav__mobile-link {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1.5rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--nav-text);\n  text-decoration: none;\n  border-left: 3px solid transparent;\n  transition: var(--nav-transition);\n}\n\n.nav__mobile-link:hover {\n  background: rgba(64, 12, 77, 0.05);\n  color: var(--nav-text-hover);\n  border-left-color: var(--nav-text-hover);\n}\n\n.nav__mobile-link--active {\n  background: rgba(64, 12, 77, 0.08);\n  color: var(--nav-active);\n  border-left-color: var(--nav-active);\n}\n\n.nav__mobile-link--sathi {\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;\n  border-left-color: #16a34a !important;\n  color: #16a34a !important;\n}\n\n.nav__mobile-footer {\n  padding: 1.5rem;\n  border-top: 1px solid var(--nav-border);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.nav__mobile-btn {\n  display: block;\n  padding: 1rem;\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #ffffff;\n  background: linear-gradient(135deg, #400C4D 0%, #5a1761 100%);\n  text-decoration: none;\n  border-radius: 10px;\n  transition: var(--nav-transition);\n  box-shadow: 0 4px 12px rgba(64, 12, 77, 0.3);\n}\n\n.nav__mobile-btn:hover {\n  background: linear-gradient(135deg, #5a1761 0%, #7a1f7f 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(64, 12, 77, 0.4);\n}\n\n/* Mobile Course Launch Button */\n.nav__mobile-launch-btn {\n  display: block;\n  padding: 1rem;\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #ffffff;\n  background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);\n  text-decoration: none;\n  border: none;\n  border-radius: 10px;\n  transition: var(--nav-transition);\n  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.3);\n  cursor: pointer;\n  animation: pulse-glow 2s ease-in-out infinite;\n}\n\n.nav__mobile-launch-btn:hover {\n  background: linear-gradient(135deg, #ea580c 0%, #f97316 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(249, 115, 22, 0.5);\n  animation: none;\n}\n\n.nav__mobile-phone {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  padding: 1rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #16a34a;\n  text-decoration: none;\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);\n  border: 2px solid #bbf7d0;\n  border-radius: 10px;\n  transition: var(--nav-transition);\n}\n\n.nav__mobile-phone:hover {\n  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);\n  border-color: #86efac;\n  transform: translateY(-1px);\n}\n\n/* ============================================\n   RESPONSIVE ADJUSTMENTS\n   ============================================ */\n\n@media (max-width: 768px) {\n  .nav__container {\n    padding: 0 1.5rem;\n  }\n\n  .nav__logo-img {\n    height: 60px;\n  }\n\n  .nav__mobile {\n    width: 280px;\n  }\n}\n\n@media (max-width: 480px) {\n  .nav__container {\n    padding: 0 1rem;\n  }\n\n  .nav__logo-img {\n    height: 45px;\n  }\n\n  .nav__mobile {\n    width: 100%;\n    max-width: 100vw;\n  }\n}\n\n/* ============================================\n   DARK MODE SUPPORT (OPTIONAL)\n   ============================================ */\n\nhtml[data-theme=\"dark\"] .nav {\n  --nav-bg: #0f172a;\n  --nav-text: #e2e8f0;\n  --nav-text-hover: #d8b4fe;\n  --nav-active: #c084fc;\n  --nav-border: #1e293b;\n}\n\nhtml[data-theme=\"dark\"] .nav__mobile {\n  background: #0f172a;\n}\n\nhtml[data-theme=\"dark\"] .nav__mobile-close {\n  background: #1e293b;\n  color: #e2e8f0;\n}\n\nhtml[data-theme=\"dark\"] .nav__mobile-close:hover {\n  background: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
